import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { TypedDispatch } from './types';
import type { RootState } from '../reducers';

export const useAppDispatch = () => useDispatch<TypedDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
